import api from '@/services/api';
import { ProviderNotification } from '@/types/provider-notification';
import { useAuthHydration } from '@/hooks/use-auth-hydration';
import { useQuery } from '@tanstack/react-query';

export const providerNotificationKeys = {
  all: ['provider', 'notifications'] as const,
  list: (limit?: number) => [...providerNotificationKeys.all, 'list', limit] as const,
  unreadCount: () => [...providerNotificationKeys.all, 'unread-count'] as const,
};

export function useProviderNotifications(limit = 20) {
  const isHydrated = useAuthHydration();

  return useQuery({
    queryKey: providerNotificationKeys.list(limit),
    queryFn: async () => {
      const response = await api.get<ProviderNotification[]>(
        '/provider/notifications',
        { params: { limit } },
      );
      return response.data;
    },
    enabled: isHydrated,
    refetchOnWindowFocus: true,
  });
}

export function useUnreadNotificationsCount() {
  const isHydrated = useAuthHydration();

  return useQuery({
    queryKey: providerNotificationKeys.unreadCount(),
    queryFn: async () => {
      const response = await api.get<{ count: number }>(
        '/provider/notifications/unread-count',
      );
      return response.data.count;
    },
    enabled: isHydrated,
    refetchOnWindowFocus: true,
  });
}
